import { FunctionComponent, useEffect } from "react";
import ProductCard from "../../ProductCard";
import "./styles.scss";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "../../common/Loading";

type Props = {
  products: Product[];
  totalProducts: number;
  setSelectedPage: (page: number) => void;
  selectedPage: number;
};

const CategoryBodyMobile: FunctionComponent<Props> = ({
  products,
  setSelectedPage,
  selectedPage,
  totalProducts,
}) => {
  const scrollY = localStorage?.getItem("scrollY");

  useEffect(() => {
    if(scrollY) {
      window.scrollTo(0, Number(scrollY));
      localStorage.removeItem("scrollY");
    }
  }, [])

  return (
    <section className="category__body">
      <InfiniteScroll
        dataLength={products?.length}
        hasMore={products.length < totalProducts}
        loader={<Loading />}
        next={() => setSelectedPage(selectedPage + 1)}
        className="category__products-container"
      >
        {products?.map((product) => {
          return (
            <ProductCard
              key={product.sku}
              img={product.thumbnailUrl}
              title={product.title}
              friendlyUrl={product.friendlyUrl}
              sku={product.sku}
            />
          );
        })}
      </InfiniteScroll>
    </section>
  );
};

export default CategoryBodyMobile;
